"use client";

import { c as _c } from "react/compiler-runtime";
import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useState } from 'react';
import { DEFAULT_CACHE_CONFIG } from '@/lib/config/query-cache-config';
import { isAuthError } from '@/lib/query-auth-error';
interface QueryProviderProps {
  children: React.ReactNode;
}
export default function QueryProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp4);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ReactQueryDevtools data-imp-o="providers/query-provider.tsx:60:7" initialIsOpen={false} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== queryClient) {
    t2 = <QueryClientProvider data-imp-o="providers/query-provider.tsx:58:5" client={queryClient}>{children}{t1}</QueryClientProvider>;
    $[1] = children;
    $[2] = queryClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp4() {
  const client = new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: () => {
        client.invalidateQueries({
          refetchType: "none"
        });
      }
    }),
    defaultOptions: {
      queries: {
        ...DEFAULT_CACHE_CONFIG,
        retry: _temp,
        retryDelay: _temp2
      },
      mutations: {
        retry: 1,
        retryDelay: 1000,
        onError: _temp3
      }
    }
  });
  return client;
}
async function _temp3(error_0) {
  if (isAuthError(error_0)) {
    console.log("[QueryProvider] Auth error detected in mutation - redirecting to login");
    window.location.href = "/auth/login";
  }
}
function _temp2(attemptIndex) {
  return Math.min(1000 * 2 ** attemptIndex, 30000);
}
function _temp(failureCount, error) {
  if (isAuthError(error)) {
    return false;
  }
  if (error instanceof Error && error.message?.includes("fetch")) {
    return failureCount < 3;
  }
  return failureCount < 1;
}